import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const { search, hash } = useLocation();

  return useMemo(() => new URLSearchParams(`${search}${hash}`), [search, hash]);
};
